<template>
    <div>
        <!-- 申请信托审核 -->
        <van-dialog v-if="auditStatus == '8'" v-model="confirmLoanAuditShow" :title="auditTitle" show-cancel-button
            :before-close="auditPass" @cancel="confirmLoanAuditShow = false">

            <van-field style="margin: 10px 0" type="number" label="本次放款" clearable v-model="advanceAmount"
                :error-message="advanceAmountErr" />

            <van-field style="margin: 10px 0" type="text" label="补充材料" readonly clearable @click="documentShow"
                :error-message="supDocumentErr" placeholder="单击可选择" v-model="supDocument" />

            <van-radio-group v-model="conditionalPass" @change="conditionalPassChange">
                <div style="padding: 20px 0 10px 20px;font-size: 14px;color:#07c160">
                    <van-icon name="info-o" />
                    是否有条件通过
                </div>
                <van-cell-group>
                    <van-cell title="正常批贷" clickable @click="clickConditional('normal')">
                        <van-radio slot="right-icon" name="normal" />
                    </van-cell>
                    <van-cell title="放款后需补充担保措施" clickable @click="clickConditional('needSup')">
                        <van-radio slot="right-icon" name="needSup" />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>

            <van-field style="margin: 10px 0" type="textarea" label="审批意见" clearable :error-message="remarkErr"
                placeholder="请输入审批意见" v-model="remark" />

        </van-dialog>

        <van-dialog title="补充资料" :before-close="confirmSupDocument" show-cancel-button v-model="supDocumentShow">
            <van-checkbox-group v-model="supDocumentTemp">
                <van-cell-group>

                    <van-cell clickable title="他项权利" @click="toggle(1)">
                        <van-checkbox name="他项权利" ref="supDoc1" slot="right-icon" />
                    </van-cell>

                    <van-cell clickable title="转账凭证" @click="toggle(2)">
                        <van-checkbox name="转账凭证" ref="supDoc2" slot="right-icon" />
                    </van-cell>

                </van-cell-group>
            </van-checkbox-group>
        </van-dialog>
    </div>
</template>

<script>
import { auditProcess } from '@/api/loanInfo'
import { eventBus } from '@/vue/utils/eventBus'
import { mapGetters } from 'vuex'

const _ = require('lodash')
export default {
    name: 'trust-loan-approval-dialog',
    props: {
        applyId: {
            type: String,
            default: ''
        }
    },
    watch: {
        'remark'(val) {
            if (val == undefined || val.length > 0) {
                this.remarkErr = ''
            }
        },
        'advanceAmount'(val) {
            if (val == undefined || val.length > 0) {
                this.advanceAmountErr = ''
            }
        }
    },
    components: {
    },
    computed: mapGetters([
        'auditStatus',
        'applyInfo',
        'userId',
        'userName',
        'name'
    ]),
    data() {
        return {
            conditionalPass: 'normal',
            supDocumentTemp: [],
            supDocument: '',
            supDocumentErr: '',
            supDocumentColumns: ['他项权利', '转账凭证'],
            load: true,
            value: '',
            index: -1,
            loading: false,
            finished: false,
            show: false,
            activate: [],
            advanceAmount: '',//本次放款金额
            advanceAmountErr: '',//本次放款金额
            confirmLoanAuditShow: false,
            supDocumentShow: false,
            showDoc: false,//是否可以选择补充资料
            remark: '',
            remarkErr: '',
            auditTitle: '',
        }
    },
    mounted() {
        let self = this
        eventBus.$on('trustLoanApprovalAudit', function (type) {
            // 申请信托审核
            self.auditTitle = '申请信托审核'
            self.confirmLoanAuditShow = true
        })

        self.advanceAmount = self.applyInfo.advanceAmount
    },
    destroyed() {
        eventBus.$off('trustLoanApprovalAudit')
    },
    methods: {
        toggle(index) {
            if (index == 1) {
                this.$refs.supDoc1.toggle();
            } else {
                this.$refs.supDoc2.toggle();
            }
        },
        auditPass(action, done) {
            if (action === 'confirm') {
                //补充担保措施需要验资 补充材料
                if (this.conditionalPass == 'needSup' && !this.supDocument) {
                    this.$toast('请选择补充材料')
                    done(false)
                    return false
                }

                //审批意见校验
                if (!this.remark) {
                    this.remarkErr = '请输入审批意见'
                    done(false)
                    return false
                }

                //提交请求
                let params = {
                    applyId: this.applyId,
                    type: 'pass',
                    process: 'TRUST_LOAN_APPROVAL',
                    remark: this.remark,
                    conditionalPass: this.conditionalPass
                }

                //需要补充资料
                if (this.conditionalPass == 'needSup') {
                    params.supDocument = this.supDocument
                }
                auditProcess(params).then(res => {
                    done()
                    if (res.success) {
                        this.$toast(res.msg)
                        this.$router.go(-1)
                    } else {
                        this.$toast(res.msg)
                    }
                })

            } else {
                this.remarkErr = ''
                done()
            }
        },
        conditionalPassChange(val) {
            this.conditionalPass = val
            //不能再选补充材料
            if (val == 'normal') {
                this.showDoc = false
                //清空补充材料
                this.supDocument = ''
            } else {
                this.showDoc = true
            }
        },
        clickConditional(val) {
            this.conditionalPass = val
            //不能再选补充材料
            if (val == 'normal') {
                this.showDoc = false
                this.supDocument = ''
            } else {
                this.showDoc = true
            }
        },
        documentShow() {
            if (this.showDoc) {
                this.supDocumentShow = true
            } else {
                this.$toast('正常批贷无需补充材料')
            }
        },

        confirmSupDocument(action, done) {
            console.log(action, this.supDocumentTemp.length)
            if (action === 'confirm') {
                if (this.supDocumentTemp.length > 0) {
                    this.supDocument = this.supDocumentTemp.join(',')
                    console.log(this.supDocument)
                }
            } else {

            }
            done()
        },
    }
}
</script>

<style scoped></style>
